<script setup lang="ts">
import {onMounted} from 'vue';
import PlayerModal from './components/PlayerModal.vue';
import VideoItem from './components/VideoItem.vue';
import {useStore} from './store';

const store = useStore();

onMounted(() => {
    store.fetchVideos();
});
</script>

<template>
    <div class="video-grid">
        <VideoItem
            :key="index"
            :video="video"
            v-for="(video, index) in store.videos"
        />
    </div>
    <PlayerModal />
</template>
